import type { PropsWithChildren } from 'react';
import { DocsSidebar } from './DocsSidebar/DocsSidebar';
import styles from './DocsLayout.module.css';

/**
 * The content of `PluginPage` on every docs page: the docs sidebar on the
 * left, the page content on the right.
 */
export function DocsLayout({ children }: PropsWithChildren<{}>) {
  return (
    <div className={styles.root}>
      <div className={styles.sidebar}>
        <DocsSidebar />
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}
